module.exports = __webpack_public_path__ + "static/media/partner-zzgsyh@2x.2f18ad95.png";